__turbopack_context__.v({
  "full-page-container": "dGf0Ta_full-page-container",
  "is-visible": "dGf0Ta_is-visible",
  "wrapper": "dGf0Ta_wrapper",
});
